<template>
    <group-report-template  v-model:current-report-template-id="currentReportTemplateId"
                            v-model:for-group="forGroup"
                            v-model:interval="$data._interval"
                            v-model:ran-report="$data._reportSuccessfullySent"
                            v-model:reload-data="$data._reloadTable"
                            v-model:running-errors="$data._errorSending"
                            v-model:running-report="$data._runningReport"
                            v-model:settings="$data._settings"
                            :can-edit="permissions.can('manage_excursion_report')"
                            :default-settings="defaultSettings"
                            :prepare-settings-function="$data._prepareSettingsFunction"
                            report-name="excursion-report"
                            v-model:display-section="displaySection"
                            @useStandardReporting="setUseStandardReporting"
                            @reset-settings="resetSelections"
    >
        <template   #create-settings>
            <!-- Add Excursion Report Settings -->
            <excursion-report-settings
                v-model:interval="$data._interval"
                v-model:settings="$data._settings"
                :is-savable="true"
            ></excursion-report-settings>
        </template>

        <template   #edit-settings>
            <!-- Add Excursion Report Settings -->
            <excursion-report-settings
                v-model:interval="$data._interval"
                v-model:settings="$data._settings"
                :is-savable="displaySection === 'show-template' || useStandardReporting"
            ></excursion-report-settings>
        </template>

        <template   #run-options="props">
            <meter-interval-selection   v-model:end-of-interval="endOfInterval"
                                        v-model:interval="$data._interval"
                                        v-model:selected-meters="$data._selectedMeters"
                                        v-model:semi-month-half="$data._semiMonthHalf"
                                        :meters="metersByGroup[props.groupId]"
                                        :max-date="maxDate"
                                        :min-date="minDate"
                                        :timezone="timezone"
                                        @run-report="runReport(currentReportTemplateId)"
            ></meter-interval-selection>
        </template>
    </group-report-template>
</template>

<script>
import axios from "axios"
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import {SonicuCoreMixin} from "../../mixins/SonicuCoreMixin";
import {ajaxTableMixin} from "../../mixins/ajaxTableMixin";
import {Intervals} from "./Intervals";
import ReportHomeModal from "./ReportHomeModal";
import ButtonBlueSecondary from "../elements/buttons/ButtonBlueSecondary";
import BaseReport from "../Reports/BaseReport";
import MeterIntervalSelection from "./MeterIntervalSelection";
import DetailedAlarmReportSettings from "./DetailedAlarmReportSettings";
import AjaxTable from "../elements/AjaxTable";
import Select2 from "../elements/select2";
import SlideOverPanel from "../elements/SlideOverPanel";
import ButtonRedSecondary from "../elements/buttons/ButtonRedSecondary";
import ButtonGreenPrimary from "../elements/buttons/ButtonGreenPrimary";
import GroupReportTemplate from "./GroupReportTemplate";
import ExcursionReportSettings from "./ExcursionReportSettings";

export default {
    name: "GroupExcursionReport",
    mixins: [SonicuCoreMixin, ajaxTableMixin],
    components: {
        ExcursionReportSettings,
        GroupReportTemplate,
        ButtonGreenPrimary,
        ButtonRedSecondary,
        SlideOverPanel,
        AjaxTable,
        DetailedAlarmReportSettings, MeterIntervalSelection, BaseReport, ReportHomeModal, ButtonBlueSecondary, Select2,
        Menu, MenuButton, MenuItem, MenuItems,
    },
    props: {
        receiveWeekday: {
            type: Number,
            default: 1,
        },
        interval: {
            type: String,
            default: 'monthly',
        },
        minDate: {
            type: Date,
        },
        maxDate: {
            type: Date,
        },
        defaultSettings: {
            type: Object,
            default() {
                return {}
            }
        },
        metersByGroup: {
            type: Object,
            default() {
                return {}
            }
        },
        timezone: {
            type: String,
        },
    },
    data() {
        return {
            displaySection: null,

            // Manual Run Stuff
            _interval: this.interval,
            endOfInterval: new Date(),
            _semiMonthHalf: 'first',
            _selectedMeters: [],
            _templateName: '',
            _groupId: null,
            _prepareSettingsFunction: null,

            _data: [],
            _settings: this.defaultSettings,

            _reloadTable: false,
            _runningReport: false,
            _reportSuccessfullySent: false,
            _errorSending: [],

            currentReportTemplateId: null,
            forGroup: false,
            useStandardReporting: false,
        }
    },
    created() {
        this.$data._prepareSettingsFunction = (settings) => {
            // We must make sure that the log time is a value and a proper JS Date
            settings.logTime1 = _.isDate(settings.logTime1) ? settings.logTime1 : new Date(settings.logTime1)
            settings.logTime2 = _.isDate(settings.logTime2) ? settings.logTime2 : new Date(settings.logTime2)
            return settings
        }
    },
    mounted() {

    },
    methods: {
        runReport(reportTemplateId = null) {
            let params = {}
            if (reportTemplateId !== null) {
                params['reportTemplateId'] = reportTemplateId
                params['forGroup'] = this.forGroup
            }
            else {
                params['interval'] = this.$data._interval
                params['settings'] = this.$data._settings
            }

            params['end'] = this.endOfInterval
            params['meters'] = this.$data._selectedMeters

            if (this.endOfInterval === Intervals.SEMI_MONTHLY) {
                params['semiMonthHalf'] = this.$data._semiMonthHalf
            }

            // return
            this.$data._runningReport = true
            axios.post(this.company.buildCompanyRoute('group-reports/excursion-report'), params)
                .then(response => {
                    // Clear the error logs, since the report is done.
                    this.$data._reportSuccessfullySent = true
                    this.$data._errorSending = []
                })
                .catch(response => {
                    // Store the logs from errors to show.
                    this.$data._errorSending = response.data
                })
                .finally(() => {
                    // Finish the sending of the report.
                    this.$data._runningReport = false
                })
        },
        resetTemplateRun() {
            this.currentReportTemplateIndex = null
            this.forGroup = false
        },
        setUseStandardReporting(event) {
            this.useStandardReporting = event
        },
        resetSelections() {
            this.$data._selectedMeters = []
        },
    },
    computed: {},
    watch: {
        settings (val, old) {
            if (val !== old) {
                this.$data._settings = val
            }
        },
    },
}
</script>

<style scoped>

</style>